export enum Reason {
  Harassment = 'Harassment',
  Spam = 'Spam',
  SellingIllegalDrugs = 'Selling illegal drugs',
  DangerousAdvice = 'Dangerous advice',
  SelfHarm = 'Self-harm',
  ViolentOrObsceneContent = 'Violent or obscene content',
  HateSpeech = 'Hate speech',
  UnderageMember = 'Underage member',
  SomethingElse = 'Something else',
}

export const examples: Record<Reason, string> = {
  [Reason.Harassment]: 'Stalking, threats, bullying, trolling',
  [Reason.Spam]: 'Unauthorised sales, scams, fake accounts',
  [Reason.SellingIllegalDrugs]: 'Supply or offer to supply controlled substances',
  [Reason.DangerousAdvice]: 'Misinformation that could cause harm',
  [Reason.SelfHarm]: 'Suicide, drug abuse, eating disorder',
  [Reason.ViolentOrObsceneContent]: 'Violent, disturbing, sexual',
  [Reason.HateSpeech]: 'Based on disability, race, religion, gender identity or sexual',
  [Reason.UnderageMember]: 'Person under 18 years',
  [Reason.SomethingElse]: 'Violates %1$scommunity guidelines%2$s or other',
};

export const requiresComment = [
  Reason.Harassment,
  Reason.DangerousAdvice,
  Reason.ViolentOrObsceneContent,
  Reason.HateSpeech,
  Reason.UnderageMember,
  Reason.SomethingElse,
];
